module.exports = __webpack_public_path__ + "img/4.ebff8c0d.png";